export const IS_TEST_ENV = process.env.BABEL_ENV === 'test';
export const SESSION_STORAGE_GSCOPE_MODULE_LIST_KEY = '__GSCOPE_MFE_MODULE_LIST__';
